import React, {
  useMemo,
} from 'react';
import clsx from 'clsx';
import Table from 'core/components/VirtualTable';
import {
  LeanClaimSummaryDTO,
} from 'dtos';
import {
  VirtualTableColumnDef as ColumnDef,
} from 'core/components/VirtualTable/types';
import getClaimPreviewColumns from 'pages/Dashboard/pages/Billing/Charges/BulkClaim/previewColumns';

type Props = {
  claims: LeanClaimSummaryDTO[];
  onRemove?: (claimId: number) => void;
  emptySlot?: string;
  muted?: boolean;
  className?: string;
};

export default function ClaimPreview({
  claims,
  onRemove,
  emptySlot = 'No claims.',
  muted = false,
  className,
}: Props) {
  const columns = useMemo(() => getClaimPreviewColumns(onRemove), [onRemove]);

  return (
    <div className={clsx('flex flex-col border border-gray-200 rounded-md overflow-hidden', { 'opacity-70': muted })}>
      <div className={clsx('flex flex-1 flex-col w-full', className)}>
        <Table<LeanClaimSummaryDTO>
          columns={columns as ColumnDef<LeanClaimSummaryDTO>[]}
          data={claims}
          skeleton={{
            rows: 3,
          }}
          emptySlot={emptySlot}
          getRowId={(row) => row?.claimId ?? 0}
          classes={{
            body: clsx('!m-0 !p-0', muted ? '!bg-gray-50' : '!bg-white'),
            scrollContainer: '!p-0',
            column: '!text-left',
            outerRow: '!w-full last:!border-b-0',
            outerHeader: '!bg-gray-100 !rounded-sm py-1',
            header: '!text-gray-700 !py-0 !border-0',
            scrollbarGutter: 'inherit',
            windowsClassName: '!w-full',
            row: '!py-1',
            root: '!pb-0',
          }}
        />
      </div>
    </div>
  );
}
